import { RateSchedule } from "./RateSchedule";
export class RateSchedules {
    _schedules = [];
    _modified = false;
    constructor(schedules = []) {
        this.schedules = schedules;
        this.updateJsValues();
        this.modified = false;
    }
    resetModified() {
        this.modified = false;
        this._schedules.forEach((bm) => (bm.modified = false));
    }
    set modified(value) {
        this._modified = value;
    }
    get modified() {
        return this._modified || false;
    }
    get hasModified() {
        return this.modified || this._schedules.some((bm) => bm.modified);
    }
    updateModelValues() {
        this._schedules.forEach((bm) => bm.updateModelValues());
    }
    updateJsValues() {
        this._schedules.forEach((bm) => bm.updateJsValues());
    }
    get schedules() {
        return this._schedules;
    }
    set schedules(value) {
        // check type and inflate if necessary
        this._schedules = value.map((c) => {
            if (c instanceof RateSchedule) {
                return c;
            }
            return new RateSchedule(c);
        });
        this.modified = true;
    }
    get all() {
        return this._schedules;
    }
    get allCustom() {
        return this._schedules.filter((c) => c.type === "custom");
    }
    get allCustomAsObject() {
        return new RateSchedules(this._schedules.filter((c) => c.type === "custom"));
    }
    get hasCustom() {
        return this.allCustom.length > 0;
    }
    addSchedule(schedule) {
        this.modified = true;
        this._schedules.push(schedule);
    }
    addScheduleAtTheBeginning(schedule) {
        this.modified = true;
        this._schedules.unshift(schedule);
    }
    removeScheduleById(id) {
        this.modified = true;
        const index = this._schedules.findIndex((c) => c.id === id);
        if (index > -1) {
            this._schedules.splice(index, 1);
        }
    }
    removeScheduleAtIndex(index) {
        this.modified = true;
        this._schedules.splice(index, 1);
    }
    get length() {
        return this._schedules.length;
    }
    atIndex(index) {
        return this._schedules[index];
    }
    get first() {
        return this._schedules[0];
    }
    get last() {
        return this._schedules[this._schedules.length - 1];
    }
    get json() {
        const json = this._schedules.map((s) => s.json);
        return json;
    }
}
